import { createContext, useContext } from 'react';
import type { DSCtxValue } from './types';

export const DeepSignalCtx = createContext<DSCtxValue>({ apiData: null, loading: false, error: null });

export function useDeepSignal(): DSCtxValue {
  return useContext(DeepSignalCtx);
}
